module.exports = __webpack_public_path__ + "img/83.75a6b4c7.png";